import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-candidate',
  templateUrl: './user-candidate.component.html',
  styleUrls: ['./user-candidate.component.css']
})
export class UserCandidateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
